function cov_sh376gwj9() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Menu.tsx";
  var hash = "4fa73d74be9219cb848ec7b7942ed6255debf152";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Menu.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4fa73d74be9219cb848ec7b7942ed6255debf152"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_sh376gwj9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_sh376gwj9();
var Icon = (cov_sh376gwj9().s[0]++, {
  name: 'menu',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.75 5C1.75 4.30964 2.30964 3.75 3 3.75H21C21.6904 3.75 22.25 4.30964 22.25 5C22.25 5.69036 21.6904 6.25 21 6.25H3C2.30964 6.25 1.75 5.69036 1.75 5ZM1.75 12C1.75 11.3096 2.30964 10.75 3 10.75H21C21.6904 10.75 22.25 11.3096 22.25 12C22.25 12.6904 21.6904 13.25 21 13.25H3C2.30964 13.25 1.75 12.6904 1.75 12ZM1.75 19C1.75 18.3096 2.30964 17.75 3 17.75H21C21.6904 17.75 22.25 18.3096 22.25 19C22.25 19.6904 21.6904 20.25 21 20.25H3C2.30964 20.25 1.75 19.6904 1.75 19Z\" fill=\"currentColor\"/>"
});
export default Icon;